import React from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Ratio from 'react-bootstrap/Ratio';
import { Link } from 'react-router-dom';
import './product-slider.css';

const toPlainText = (html) => {
  if (!html) return '';
  if (typeof window === 'undefined') {
    return String(html).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || div.innerText || '').trim();
};

const formatNGN = (value) => {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `₦${n.toLocaleString()}`;
  }
};

export default function ProductCard({ item, showGenPrice = false, onShop }) {
  const price = showGenPrice ? item?.gen_price : item?.price;
  const titleText = toPlainText(item?.title || '');
  const descText  = toPlainText(item?.description || '');

  // ✅ Route to the correct detail page WITH the product id
  const detailPath = `/detail_page/${item?.id}`;

  return (
    <div className="product-col p-3 h-100">
      <Card className="product-card h-100 shadow-sm">
        {/* Clickable card area -> detail page with id */}
        <Link to={detailPath} state={{ item }} className="product-link">
          <Ratio aspectRatio="4x3" className="product-img-wrap">
            <Card.Img
              variant="top"
              src={item?.thumbnail}
              alt={titleText || 'Product image'}
              className="product-img"
            />
          </Ratio>

          <Card.Body className="product-body d-flex flex-column">
            <Card.Title className="product-title clamp-3">{titleText}</Card.Title>
            <Card.Text className="product-desc clamp-4">{descText}</Card.Text>
          </Card.Body>
        </Link>

        <div className="product-separator" />

        {/* Price above button; button also routes to the same detail page */}
        <Card.Footer className="product-footer">
          <div className="product-price">
            <span className="price-currency">₦</span>
            <span className="price-amount">{formatNGN(price).replace('₦', '')}</span>
          </div>

          <Button
            as={Link}
            to={detailPath}
            state={{ item }}
            variant="primary"
            className="product-btn"
            onClick={onShop}
          >
            Shop Now
          </Button>
        </Card.Footer>
      </Card>
    </div>
  );
}
